import type { Employee, EmployeeUpdate } from '@sysarb/sysarb-types/services/v1/employee';
import type { Guid } from 'guid-typescript';
import type { useResgate, Model } from '@/login/composables/useResgate';
import { useLoginStore } from '@/login/stores/useLoginStore';

export class EmployeeService {
    public async get(resgate: ReturnType<typeof useResgate>, employeeId: Guid | string): Promise<Model<Employee> | null> {
        const { instanceTopic } = useLoginStore();
        return resgate.model<Employee>(`v1.${instanceTopic}.employee.${employeeId}`).then(res => {
            if (res?.success === false) {
                return null;
            }
            return res.data;
        });
    }

    public async update(resgate: ReturnType<typeof useResgate>, employeeId: Guid | string, updateData: EmployeeUpdate): Promise<void | null> {
        const { instanceTopic } = useLoginStore();
        return resgate.call<void>(`v1.${instanceTopic}.employee.${employeeId}`, 'update', updateData).then(res => {
            if (res?.success === false) {
                return null;
            }
            return res.data;
        });
    }
}
